import { QRCodeCanvas } from "qrcode.react";

function getRandomPresetColor() {
  const colors = ["#DC143C", "#00008B", "#0000FF", "#800080"]; // Crimson Red, Dark Blue, Blue, Purple,  Dark Yellow
  return colors[Math.floor(Math.random() * colors.length)];
}

function HiddenQRCode({ id, value }) {
  return (
    <QRCodeCanvas 
      id={id} 
      value={value} 
      size={128} 
      includeMargin={true} 
      style={{ display: "none" }}
      fgColor={getRandomPresetColor()} // Generate a random color from the specified set
    />
  );
}

export default HiddenQRCode;